import SeoArticlesLoader from "../classes/layout/SeoArticlesLoader";

class SeoArticlesLoaderController {
    constructor() {
        this.init();
    }

    init() {
        // Only initialize on articles listing page
        if (document.getElementById('articles-container')) {
            new SeoArticlesLoader();
        }
    }
}

export default SeoArticlesLoaderController;

